/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-explicit-any */

import { useState } from "react";
import * as yup from "yup";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import {
    Formik,
    FormikProps,
    Form,
    Field,
    ErrorMessage,
    FormikActions,
} from "formik";
import { WebLayout } from "../components/web-layout";
import { FormikErrorMessage } from "../components/formik-error-message";
import { Spinner } from "../components/spinner";
import { API } from "../../utils/AxiosInstance";
import Error from "../health/components/widget/form/error-message";
import { Spacer } from "../components/spacer";
import { JotFormDialog } from "./jotform-dialog";

interface State {
    code: string;
    errorMessage: string;
}
export function UserSignupComponent() {
    const [errorMessage, seterrorMessage] = useState("");
    const [url, setUrl] = useState("");
    const [showPopup, setShowPopup] = useState(false);
    const { t } = useTranslation();

    const schema = yup.object().shape({
        code: yup.string().required(t("is required")),
    });

    const onSubmit = async (values: State, actions: FormikActions<State>) => {
        const param = values.code;
        try {
            const response = await API.post<{
                coupon: string;
                external_url: string;
            }>("/coupons", {
                coupon: param,
            });
            actions.setSubmitting(false);
            if (response.data.coupon) {
                setUrl(response.data.external_url);
                setShowPopup(true);
            } else {
                seterrorMessage("Coupon is not valid");
            }
        } catch (error: any) {
            actions.setSubmitting(false);
            toast.error((error as Error)?.message || "An error occurred");
        }
    };

    const handleChange = (e: React.ChangeEvent<any>) => {
        const { maxLength, value, name } = e.target;
        const fieldIndex = name.split("_")[1] as string;

        if (value.length >= maxLength) {
            if (parseInt(fieldIndex, 10) < 3) {
                const nextSibling = document.querySelector(
                    `input[name=code_${parseInt(fieldIndex, 10) + 1}]`
                );

                if (nextSibling !== null) {
                    (nextSibling as HTMLElement)?.focus();
                }
            }
        }
    };
    return (
        <WebLayout showFooter={false}>
            <p className="font-medium text-xl text-align-center">
                ENTER REGISTRATION CODE
            </p>
            {showPopup && (
                <JotFormDialog url={url} onClose={() => setShowPopup(false)} />
            )}
            <Formik
                initialValues={{
                    code: "",
                    errorMessage: "",
                }}
                onSubmit={onSubmit}
                validationSchema={schema}
                render={(formikProps: FormikProps<State>) => (
                    <Form
                        placeholder={undefined}
                        onPointerEnterCapture={undefined}
                        onPointerLeaveCapture={undefined}
                    >
                        <Error message={errorMessage} />
                        <div className="row justify-content-center">
                            <div className="col padding-right-10">
                                <div className="pb">
                                    <Field
                                        type="code"
                                        name="code"
                                        className="form-control"
                                        onInput={handleChange}
                                    />
                                    <ErrorMessage
                                        name="code"
                                        component={FormikErrorMessage}
                                    />
                                </div>
                            </div>
                        </div>
                        <Spacer />
                        <button
                            type="submit"
                            className="btn btn-success form-control"
                            disabled={formikProps.isSubmitting}
                        >
                            {" "}
                            {formikProps.isSubmitting && <Spinner />}{" "}
                            {t("SUBMIT")}
                        </button>
                    </Form>
                )}
            />
            <span className="form-text text-muted font-italic">
                Note: for best results open this page in the Chrome or Firefox
                browser. If you are using Safari, you will need to enable popups
                in your preferences.
            </span>
        </WebLayout>
    );
}

export default UserSignupComponent;
